export default __webpack_public_path__ + "static/logo-horizontal-on-white-bf3241efd7594aa11c633828a62da12c.png";